import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=bda61f7a&scoped=true"
var script = {}
import style0 from "./FooterView.vue?vue&type=style&index=0&id=bda61f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda61f7a",
  null
  
)

export default component.exports